


















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class LanguagesBtns extends Vue {
  @Prop({ type: String, default: "" }) value!: string;

  get currentLocale(): string {
    return this.value;
  }

  set currentLocale(lang: string) {
    this.$emit("input", lang);
  }

  updateLocale(lang: string) {
    this.currentLocale = lang;
  }
}
export default LanguagesBtns;
